import anime from 'animejs';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';

export class Body extends ConnectedComponent {
  didMount() {
    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'startHideAnimation') {
        location.hash && this.scroll(location.hash);
      }
    });
  }

  scroll(selector: string) {
    const element = document.querySelector(selector);
    const {top = 0} = element?.getBoundingClientRect() || {};
    const windowScrollY = window.scrollY || window.pageYOffset;
    const y = top + windowScrollY;
    const scroll = {y: windowScrollY};

    anime({
      duration: 600,
      easing: 'easeOutCubic',
      targets: scroll,
      update: () => {
        window.scrollTo(0, scroll.y);
      },
      y,
    });
  }
}
